<template>

  <div v-if="!waitingVerificationResult" class="verify-modal-body">
    <h2>VERIFY YOUR IDENTITY</h2>
    <p class="text-center">For security purposes and to comply with government regulations, we need to verify the identity of the person that setup this account. It's a quick and easy process and once verified, we will not keep any of your personal data.</p>
    <a href="JavaScript:void(0);" @click="sendToStripe">Click here to securely verify with Stripe Identity</a>
  </div>
  <div v-else class="verify-modal-body">
    <h2>Thank you</h2>
    <p class="text-center">We are waiting for the results to come back from Stripe. This should not take long at all. Please refresh this page after 5 minutes.</p>
  </div>

</template>

<script>
export default {
  name: "IdentityVerification",
  data() {
    return {
      verifyCustomerWithStripe: '',
      waitingVerificationResult: false,
      email: ''
    }
  },
  async beforeMount() {
    // TODO: this needs looking at why we cant use props or data element ?!?
    //this.email = this.$el.parent.getAttribute("data-email");
    await this.performStripeVerification();
  },
  methods: {
    async performStripeVerification() {
      const urlToCall = `${window.location.origin}/create-verification-session`;

      await fetch(urlToCall,{
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({EmailAddress: "nate+gt@grouptogether.com"}),
          })
          .then((resp) => {
             this.verifyCustomerWithStripe = resp.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    sendToStripe() {
      window.open(this.verifyCustomerWithStripe, '_blank'); 
      this.waitingVerificationResult = true;
    }
  }
}
</script>

<style scoped>

</style>